import { useEffect, useState } from 'react';
import './App.css';

type EventType = {
  title: string;
  description: string;
  date: Date;
  image: string; // to the cover url
  type: string;
};

function App() {
  const [events, setEvents] = useState<EventType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch("https://flat-snowflake-dac4.massimiliano-manselli.workers.dev")
      .then((response) => response.json())
      .then((data) => {
        const mappedEvents = data.results.map((event: any) => ({
          title: event.properties.Name.title[0].text.content,
          description: event.properties.description.rich_text[0]?.text.content || 'No description',
          date: new Date(event.properties.Date.date.start),
          image: event?.cover ? event?.cover?.file?.url : '',
          type: event.properties.type.rich_text[0]?.text.content || 'No type',
        }));
        setLoading(false);
        setEvents(mappedEvents);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);


  return (
    <div className="app">
      {loading &&
        <div className='loading-overlay'>
          <div className='loader'></div>
        </div>
      }
      <h2>Eventi</h2>
      <div className="events-container">
        {events.map((event, index) => (
          <div key={index} className="event-card">
            <img src={event.image ? event.image : '/placeholder.png'} alt={event.title} className="event-cover" />
            <div className="event-info">
              <h3 className="event-title">{event.title}</h3>
              <p className="event-description">{event.description}</p>
              <div className="event-tags">
                <span className="event-date">{event.date.toLocaleDateString()} {event.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                <span className="event-type">{event.type}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
